// =============================================================================
// TableFlat — Data table for operational apps
// =============================================================================

import clsx from "clsx";

interface Column<T> {
  key: string;
  header: string;
  render?: (row: T) => React.ReactNode;
  className?: string;
}

interface TableFlatProps<T> {
  columns: Column<T>[];
  data: T[];
  keyField: keyof T;
  onRowClick?: (row: T) => void;
  selectedKey?: string;
  className?: string;
}

export function TableFlat<T>({
  columns,
  data,
  keyField,
  onRowClick,
  selectedKey,
  className,
}: TableFlatProps<T>) {
  return (
    <table className={clsx("table-flat", className)}>
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key} className={col.className}>
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="text-center text-[var(--text-muted)] py-8">
              No data
            </td>
          </tr>
        ) : (
          data.map((row) => {
            const rowKey = String(row[keyField]);
            const selected = selectedKey != null && rowKey === selectedKey;
            return (
            <tr
              key={rowKey}
              onClick={() => onRowClick?.(row)}
              className={clsx(
                onRowClick && "cursor-pointer",
                selected && "bg-[var(--accent-light)]"
              )}
            >
              {columns.map((col) => (
                <td key={col.key} className={col.className}>
                  {col.render ? col.render(row) : String((row as Record<string, unknown>)[col.key] ?? "")}
                </td>
              ))}
            </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
}
